 export enum AdmissionVisitTypes
    {
        NewVisit = 1,
        FollowupVisit = 2,
        Other = 3
    }